import { render, staticRenderFns } from "./newsxiangqing.vue?vue&type=template&id=f88ba0fa&scoped=true"
import script from "./newsxiangqing.vue?vue&type=script&lang=js"
export * from "./newsxiangqing.vue?vue&type=script&lang=js"
import style0 from "./newsxiangqing.vue?vue&type=style&index=0&id=f88ba0fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88ba0fa",
  null
  
)

export default component.exports